// Контентный попап в рамках компонента welcome popup
// для роли "настраивать будет другой человек"

const template = /* html */`
    <div class="flex-column items-start gap-1">
        <h3>Вот что можно сделать, чтобы позже настроить «Дадату»</h3>
        <ol class="flex-column items-start gap-1">
            <li>
                Показать человеку, который будет интегрировать наши сервисы:
                <ul class="p-0 mt-0_5 flex-column items-start gap-0_5">
                    <li>
                        <a href="/api">
                            описание API для программистов,
                        </a>
                    </li>
                    <li>
                        <a href="/suggestions/usage/">
                            инструкцию по подключению «Подсказок» без разработчика,
                        </a>
                    </li>
                    <li>
                        <a href="/blog/instructions/integration-guide/">
                            полное руководство по продукту.
                        </a>
                    </li>
                </ul>
            </li>
            <li>
                После интеграции протестировать нужные сервисы. Мы активировали для вас 
                подписку по бесплатному тарифу. Обычно его достаточно, чтобы 
                проверить «Дадату». 
                <a href="/blog/instructions/integration-guide/#pricing">Часть сервисов 
                не входит в подписку</a>, но их тоже тестируют бесплатно — в рамках запросов, 
                которые мы дарим новым пользователям.
            </li>
            <li v-if="showContacts">
                Подписаться на <a href="https://t.me/+JY6I09ma0f1lZmVi">телеграм-канал 
                «Дадаты» для срочных новостей</a>.
            </li>
        </ol>
        <span v-if="showContacts">
            Если не понимаете, зачем нужна «Дадата», — почитайте, 
            <a href="/blog/cases/">как бизнес использует наши сервисы</a>. 
            Или смело 
            <a :href="'/support/' + userecho">пишите в поддержку</a> — разберемся.
        </span>
    </div>
`;

export default {
    template,
    inject: ["userecho"],
    props: { showContacts: Boolean },
};
